<mat-card class="container">
    <mat-card-title>
        <span>Solicitações de tratamento</span>
    </mat-card-title>

    <div fxLayout="column" *ngIf="!(empty$ | async) && !(error$ | async)">
        <mat-progress-bar
            mode="query"
            *ngIf="loading$ | async"
        ></mat-progress-bar>

        <table
            mat-table
            *ngIf="!(loading$ | async)"
            [dataSource]="rows$ | async"
        >
            <ng-container matColumnDef="planName">
                <th mat-header-cell *matHeaderCellDef>Plano</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.data.dental_plan.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="cardNumber">
                <th mat-header-cell *matHeaderCellDef>Número da carteirinha</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.data.dental_plan_card_number }}
                </td>
            </ng-container>

            <ng-container matColumnDef="patientPhone">
                <th mat-header-cell *matHeaderCellDef>Telefone</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.data.patient_phone }}
                </td>
            </ng-container>

            <ng-container matColumnDef="patientFirstName">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.data.patient_first_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="patientLastName">
                <th mat-header-cell *matHeaderCellDef>Sobrenome</th>
                <td mat-cell *matCellDef="let row">
                    {{ row.data.patient_last_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let row">
                    {{ getLabelForStatus(row.data.status) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let row">
                    <button
                        mat-button
                        matTooltip="Cancelar solicitação"
                        matTooltipPosition="above"
                        disabled="{{ buttonStateForStatus('cancel', row) }}"
                        (click)="cancelRequest(row)"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <button
                        mat-button
                        matTooltip="Adicionar como novo paciente"
                        matTooltipPosition="above"
                        disabled="{{
                            buttonStateForStatus('create_new_patient', row)
                        }}"
                        (click)="createNewPatient(row)"
                    >
                        <mat-icon>person_add</mat-icon>
                    </button>
                    <button
                        mat-button
                        matTooltip="Adicionar dados a paciente já existente"
                        matTooltipPosition="above"
                        disabled="{{
                            buttonStateForStatus('merge_patient', row)
                        }}"
                        (click)="mergePatient(row)"
                    >
                        <mat-icon>close_fullscreen</mat-icon>
                    </button>
                    <button
                        mat-button
                        matTooltip="Solicitar tratamento padrão"
                        matTooltipPosition="above"
                        disabled="{{
                            buttonStateForStatus('request_treatment', row)
                        }}"
                        (click)="requestTreatment(row)"
                    >
                        <mat-icon>calendar_today</mat-icon>
                    </button>
                    <div class="loading-action">
                        <mat-spinner
                            [ngStyle]="{
                                visibility: row.loading ? 'visible' : 'hidden'
                            }"
                            diameter="30"
                        ></mat-spinner>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr
                mat-row
                *matRowDef="let rowData; columns: columnsToDisplay"
            ></tr>
        </table>
        <mat-paginator
            [length]="rowCount$ | async"
            [pageIndex]="0"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
        >
        </mat-paginator>
    </div>

    <app-empty-state image="empty-box" *ngIf="empty$ | async">
        <p>Você ainda não tem solicitações de tratamentos.</p>
    </app-empty-state>

    <app-empty-state image="error-cloud" *ngIf="error$ | async">
        <p>Ocorreu um erro ao recuperar os dados</p>
        <p>Tente novamente mais tarde</p>
    </app-empty-state>
</mat-card>
